import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker/models';
import { AddlocationpopupComponent } from '../../generalpopup/addlocationpopup/addlocationpopup.component';
import { AddbranchpopupComponent } from '../../generalpopup/addbranchpopup/addbranchpopup.component';
import { ApprovepopComponent } from '../../grid/approvepop/approvepop.component';
import { ComponentCanDeactivate } from '../../PendingChangesGuard ';
import { HostListener } from '@angular/core';
import { AdddepartmentpopupComponent } from '../../generalpopup/adddepartmentpopup/adddepartmentpopup.component';
import { AdddesignationpopupComponent } from '../../generalpopup/adddesignationpopup/adddesignationpopup.component';
import { AttachmentComponent } from '../../grid/attachment/attachment.component';
@Component({
  selector: 'app-addpromotion',
  templateUrl: './addpromotion.component.html',
  styleUrls: ['./addpromotion.component.css']
})
export class AddpromotionComponent implements OnInit, ComponentCanDeactivate {
  @ViewChild('approvebar', { static: false }) approvebar;
  @ViewChild('attachmentbar', { static: false }) attachmentbar;

  formname: string = "PROMOTION";


  //Display
  formmode: string = "Add";
  rtnform: string = "";

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;
  isapprovemode: boolean = false;
  isrejectmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;

  isshowattachment: boolean = false;
  attachmentcount: number = 0;

  isshowapproval: boolean = false;

  isapprove: boolean = false;
  isreject: boolean = false;


  ismanualclose: boolean;

  //Filter
  filterstatus: string = "ALL";
  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;
  //Save Validation
  submitted: boolean;
  successfully: boolean;

  saveloading: boolean;

  //Edit Get Values
  promotionColl: any = [];
  promotionid: number = 0
  promotionBO: any = {}

  departmentColl: any = [];
  designationColl: any = [];
  gradeColl: any = [];
  empColl: any = [];

  promotionform = new FormGroup({
    promotionid: new FormControl(0),
    departmentid: new FormControl(null),
    designationid: new FormControl(null),
    gradeid: new FormControl(null),
    empid: new FormControl(null, Validators.required),
    effectivedt: new FormControl(null, Validators.required),
    fromdepartmentid: new FormControl(null),
    fromdesignationid: new FormControl(null),
    fromgradeid: new FormControl(null),
    //adjdt:new FormControl(null,Validators.required),  
    //amount:new FormControl(''), 
    descr: new FormControl(''),
    inactive: new FormControl(false),
  });

  lastdepartmentname: string = ""
  lastdepartmentid:  any = null;
  lastdesignationname: string = ""
  lastdesignationid: any = null;
  lastgradename: string = ""
  lastgradeid: any = null;
  lastpromotiondate: any = null;


  dateCustomClasses: DatepickerDateCustomClasses[];

  constructor(private appService: AppdataService, private loginService: LoginserviceService, private route: ActivatedRoute,
    public router: Router, private toastr: ToastrService, private productFindService: NgbModal, private datePipe: DatePipe) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.promotionid = params.id
      }

      if (params.rtnform !== undefined) {
        this.rtnform = params.rtnform
      }
    });
    this.fnGetParameterVariable();

    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
  }
  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.empid !== undefined) {
        this.filteremployeeid = params.empid
      }

      if (params.empname !== undefined) {
        this.filteremployeename = params.empname
      }

      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

      if (params.fromdate !== undefined) {
        this.filterfromdate = this.fnConvertDatetime(this.fnFormatDatetime(params.fromdate))
      }

      if (params.todate !== undefined) {
        this.filtertodate = this.fnConvertDatetime(this.fnFormatDatetime(params.todate))
      }
    })
  }

  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }

    });
  }



  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.promotionform.reset();
      this.fnInitializeFormGroup();

      if (this.promotionid > 0) {
        this.fngetPromotion();
      }
      this.fngetEmployee();
      this.fngetDepartment();
      this.fngetDesignation();
      this.fngetGrade();
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.promotionid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }


    this.isapprovemode = this.loginService.fnCheckUserRoleAction(this.formname, 'APPROVE')
    this.isrejectmode = this.loginService.fnCheckUserRoleAction(this.formname, 'REJECT')


    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }
  fnInitializeFormGroup() {
    this.promotionform.setValue({
      promotionid: 0,
      empid: null,
      departmentid: null,
      designationid: null,
      gradeid: null,
      effectivedt: new Date(),
      fromdepartmentid: null,
      fromdesignationid:null,
      fromgradeid:null,
      descr: '',
      inactive: false
    })
  }


  fngetEmployee() {
    var data = {
      'empid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.empColl = res.json().result;

   
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  fngetDepartment() {
    
    var data = {
      'departmentid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getDepartment(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.departmentColl = res.json().result;
            console.log(this.departmentColl)
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }



  fngetDesignation() {
    var data = {
      'designationid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getDesignation(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.designationColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  fngetGrade() {
    var data = {
      'gradeid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getGrade(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.gradeColl = res.json().result;
          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Get 
  fngetPromotion() {
    if (this.showProgress) {
      return;
    }
    var data = {
      'promotionid': this.promotionid,
      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.fngetPromotion(data)
      .subscribe(
        (res) => {
          if (res.json().status === 200) {
            this.promotionColl = res.json().result;
            var editdata = this.promotionColl[0];
            this.promotionBO = editdata;
            this.fnEditMode(editdata);
            this.fnHideProgress();

          }
          else {
            this.fnHideProgress();

            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.fnHideProgress();

          this.toastr.error('Error', err);
        })
  }



  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;
      if (this.loginService.fnCheckFornControlNotfound(this.promotionform.get('effectivedt'))) {
        this.promotionform.controls['effectivedt'].setErrors(null);
      }
     
      this.promotionform.controls['departmentid'].setErrors(null);

      //Validate
      if (this.promotionform.valid) {
  
        if (this.promotionform.get('departmentid').value===null && this.promotionform.get('designationid').value===null) {
          this.promotionform.controls['departmentid'].setErrors({'notfound': true});
          return;
        }
        // if (this.lastpromotiondate) {
        //   var _effectivedt = this.promotionform.get('effectivedt').value;

        //   if(this.loginService.fnCompareDateValidation(_effectivedt,this.lastpromotiondate)){
        //     this.promotionform.controls['effectivedt'].setErrors({'notfound': true});
        //     return
        //   }
        //   // if (Date.parse(_effectivedt) < Date.parse(this.lastpromotiondate)) {
        //   //   this.promotionform.controls['effectivedt'].setErrors({ 'notfound': true });
        //   //   return
        //   // }
        // }
        
        this.saveloading = true;


        
        //Check
        var data = {
          'promotionid': this.promotionid,
          'effectivedt': this.fnFormatDatetime(this.promotionform.get('effectivedt').value),
          'empid': this.promotionform.get('empid').value,
          'departmentid': this.promotionform.get('departmentid').value,
          'designationid': this.promotionform.get('designationid').value,
          'gradeid': this.promotionform.get('gradeid').value,
          'fromdepartmentid': this.promotionform.get('fromdepartmentid').value,
          'fromdesignationid': this.promotionform.get('fromdesignationid').value,
          'fromgradeid': this.promotionform.get('fromgradeid').value,
          'descr': this.promotionform.get('descr').value,
          'inactive': this.promotionform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }



        if (this.promotionform.get('promotionid').value > 0) {
          //Update 
          this.fnSetPromotion(data);
        }
        else {
          //Insert 
          this.fnInsertPromotion(data);
        }


      }
      else {
        console.log(this.promotionform)
      }
    } catch (ex) {
      this.saveloading = false;

      this.fnShowErrorMsg(ex);
    }
  }


  //Insert
  fnInsertPromotion(data) {

    this.appService.fnInsertPromotion(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The new Promotion has been added successfully.Insert Successfully");
            this.fnInsertActivityLog('INSERT', 0, this.fngetDescriptionRefno(data));
            
            var _result = res.json().result;           
            if (_result.length > 0) {
                this.fnEditFormEdit(_result[0].promotionid);              
            }
            // this.ismanualclose = true;
            // this.fnCloseForm();
            // var _result = res.json().result;

            // if (_result.length > 0) {
            //   var resdata = _result[0];
            //   console.log(resdata)
            //   if (resdata.length > 0) {
            //     this.fnAttachmentSave(resdata[0].promotionid);
            //   }
            // }   
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetPromotion(data) {

    this.appService.fnSetPromotion(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {
          if (res.json().result != "") {
            this.toastr.success('', "The Promotion has been updated successfully.");
            this.fnInsertActivityLog('EDIT', this.promotionid, this.fngetDescriptionRefno(data));
            this.fnEditFormEdit(this.promotionid);    
            // this.ismanualclose = true;
            // this.fnCloseForm();
          }
        }
        else {
          this.loginService.fnAPIError(res.json())
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }

  //AddDepartment
  private fnAddDepartment() {

    const modalRef = this.productFindService.open(AdddepartmentpopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetDepartment();

      if (receivedEntry > 0) {
        this.promotionform.patchValue({ departmentid: receivedEntry })
      }
    });

  }

  fnEmployeeSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.empname.toLocaleLowerCase().indexOf(term) > -1 ||
      item.staffcode.toLocaleLowerCase().indexOf(term) > -1;
  }


  //AddBranch
  private fnAddDesignation() {

    const modalRef = this.productFindService.open(AdddesignationpopupComponent, { size: <any>'l' });

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetDesignation();

      if (receivedEntry > 0) {
        this.promotionform.patchValue({ designationid: receivedEntry })
      }
    });

  }
  fnEditFormEdit(id) {

    this.promotionid=id;
    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

     let queryParams= {
        'id':id,
        'status': this.filterstatus,
        'empid': this.filteremployeeid,
        'empname': this.filteremployeename,
        'fromdate': this.fnFormatDatetime(this.filterfromdate),
        'todate': this.fnFormatDatetime(this.filtertodate),
      }
  
 
      this.router.navigate([], { relativeTo: this.route, queryParams: queryParams }).then(() => {
        this.ngOnInit();      
      });
      

  }
  //Close
  async fnCloseForm() {
    try {
      if ((this.isaddmode || this.iseditmode) && !this.ismanualclose) {
        var a = await this.loginService.fnConfirmFormLeave();
        if (a === false) {
          return false;
        }
      }

      this.ismanualclose = true;
      if (this.rtnform !== '') {
        this.router.navigate(['/' + this.rtnform]);
      }
      else {
        let navigationExtras: NavigationExtras = {
          queryParams: {
            'status': this.filterstatus,
            'empid': this.filteremployeeid,
            'empname': this.filteremployeename,
            'fromdate': this.fnFormatDatetime(this.filterfromdate),
            'todate': this.fnFormatDatetime(this.filtertodate),
          }
        }

        this.router.navigate(['/Promotion'], navigationExtras);
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnEditMode(deptBO) {
    deptBO.effectivedt = this.fnConvertDatetime(this.fnFormatDatetime(deptBO.effectivedt));
    // deptBO.adjdt=this.fnConvertDatetime(this.fnFormatDatetime(deptBO.adjdt));

    this.promotionform.setValue({
      promotionid: deptBO.promotionid,
      empid: deptBO.empid,
      departmentid: deptBO.departmentid,
      designationid: deptBO.designationid,
      gradeid: deptBO.gradeid,
      fromdepartmentid: deptBO.fromdepartmentid,
      fromdesignationid: deptBO.fromdesignationid,
      fromgradeid: deptBO.fromgradeid,
      effectivedt: deptBO.effectivedt,
      descr: deptBO.descr,
      inactive: deptBO.inactive
    });


    this.formmode = "";

    this.isaddmode = false;
    this.iseditmode = false;
    this.isdeletemode = false;
    this.isviewmode = true;

    this.fnVisibilityApproveStatus();

    this.lastdepartmentid = deptBO.fromdepartmentid;
    this.lastdepartmentname = deptBO.fromdepartmentname;
    this.lastdesignationid = deptBO.fromdesignationid;
    this.lastdesignationname = deptBO.fromdesignationname;
    this.lastgradeid = deptBO.fromgradeid;
    this.lastgradename = deptBO.fromgradename;
  }

  fnGetCurrentDepartmentDesign() {

    if (this.promotionid > 0) {
      return;
    }

    var empid = this.promotionform.get("empid").value;

    if (empid > 0) {
      for (let abo of this.empColl) {

        if (abo.empid === empid) {

          this.lastdepartmentid = abo.departmentid;
          this.lastdepartmentname = abo.departmentname;
          this.lastdesignationid = abo.designationid;
          this.lastdesignationname = abo.designationname;    
          this.lastgradeid = abo.gradeid;
          this.lastgradename = abo.gradename;          
          this.lastpromotiondate = abo.promotiondt;          
        }
      }

    }
    else {
      this.lastdepartmentid = null;
      this.lastdepartmentname = null;
      this.lastdesignationid = "";
      this.lastdesignationname = "";
      this.lastgradeid = null;
      this.lastgradename = "";
      this.lastpromotiondate = "";
    }

    this.promotionform.patchValue({
      fromdepartmentid: this.lastdepartmentid,
      fromdesignationid:this.lastdesignationid,
    })

  }

  //Approvals
  fnApproveBtnClick(type) {


    this.approvebar.formtype = type;
    this.approvebar.fnInitializeFormGroup();
    this.approvebar.fnGetApproveForms();

    this.isshowapproval = !this.isshowapproval

  }

  fnCloseApproveBtnClick(data) {
    this.isshowapproval = !this.isshowapproval

    if (data === 'DONE') {
      this.fngetPromotion();
    }

  }

  fnVisibilityApproveStatus() {

    this.isapprove = false;
    this.isreject = false;

    if (this.promotionBO.approvedstatus !== '') {
      if (this.promotionBO.approvedstatus === 'Approve') {
        this.isreject = true;
      }
      else if (this.promotionBO.approvedstatus === 'Reject') {
        this.isapprove = true;
      }
    }
    else {
      this.isapprove = true;
      this.isreject = true;
    }

  }

  fnEditBtnClick() {
    this.iseditmode = true;

    this.isviewmode = false;
  }
     //#Attachment
     fnAttachmentBtnClick() {

      const modalRef = this.productFindService.open(AttachmentComponent, { size: <any>'xxl' });
      modalRef.componentInstance.formname = this.formname;
      modalRef.componentInstance.trxid = this.promotionid;
      modalRef.componentInstance.formmode = "EDIT";
      modalRef.componentInstance.fnGetAttachment();
  
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
        if (receivedEntry === 'DONE') {
          this.fngetPromotion();
        }
      }); 
  
      // this.attachmentbar.formtype = this.formname;
      // this.attachmentbar.trxid = this.payadvid;
  
      // if (this.payadvid > 0) {
      //   this.attachmentbar.formmode = "EDIT";
      // }
      // else {
      //   this.attachmentbar.formmode = "ADD";
      // }
  
      // this.attachmentbar.fnGetAttachment();
  
      // this.isshowattachment = !this.isshowattachment
  
    }
  
  
    fnAttachmentSave(tid) {
  
      // if (this.attachmentcount > 0) {
  
      //   this.attachmentbar.formtype = this.formname;
      //   this.attachmentbar.trxid = tid;
      //   this.attachmentbar.formmode = "ADD";
  
      //   this.attachmentbar.fnSaveAttachmentByAddMode();
      // }
      // else {
      //   this.fnCloseForm();
      // }
  
    }
  
    fnSetAttachmentCount(data) {
  
      this.attachmentcount = data;
    }


  //Approvals POP
  fnShowApprovalPop(stauts) {

    const modalRef = this.productFindService.open(ApprovepopComponent, { size: <any>'l' });
    modalRef.componentInstance.formmode = stauts;
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.formid = this.promotionid;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      if (receivedEntry === 'DONE') {
        this.fngetPromotion();
      }


    });
  }


  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }

  fngetDescriptionRefno(data) {
    var rtnstr = "";
    try {
      if (data.transdt) {
        rtnstr = rtnstr + data.transdt;
      }

      if (data.empid) {
        rtnstr = rtnstr + " - " + data.empid;
      }

      if (data.empname) {
        rtnstr = rtnstr + " - " + data.empname;
      }
    } catch {

    }
    return rtnstr;
  }
  @HostListener('window:beforeunload')
  canDeactivate(): any {
    if (this.isaddmode || this.iseditmode) {
      return false;
    }
    else {
      return true;
    }
  }

  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc, companyid: this.loginService.fnGetCompanyId(),
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }
  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}